(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1best-sellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseFavourites = (section) => {
      if (section.dataset.tmsFavouritesReady) return;
      section.dataset.tmsFavouritesReady = 'true';
      const tabs = section.querySelectorAll('[data-tms-filter]');
      const cards = section.querySelectorAll('[data-tms-category]');
      const track = section.querySelector('[data-tms-track]');
      const previousButton = section.querySelector('[data-tms-previous]');
      const nextButton = section.querySelector('[data-tms-next]');
      const pagination = section.querySelector('[data-tms-pagination]');

      if (!track || !pagination) return;

      const getSliderMetrics = () => {
        const visibleCards = Array.from(cards).filter((card) => !card.hidden);
        const firstCard = visibleCards[0];
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 0;
        const step = cardWidth + gap;
        const visibleCount = step > 0 ? Math.max(1, Math.floor((track.clientWidth + gap + 1) / step)) : 1;
        const pageCount = Math.max(1, visibleCards.length - visibleCount + 1);
        return { pageCount, step };
      };

      const updatePagination = () => {
        const dots = pagination.querySelectorAll('button');
        if (!dots.length) return;
        const { step } = getSliderMetrics();
        const activeIndex = step > 0 ? Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / step))) : 0;
        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const buildPagination = () => {
        const { pageCount, step } = getSliderMetrics();
        pagination.replaceChildren();
        pagination.hidden = pageCount <= 1;
        if (pageCount <= 1) return;

        for (let index = 0; index < pageCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', `Mostrar grupo ${index + 1} de ${pageCount}`);
          dot.addEventListener('click', () => {
            track.scrollTo({ left: index * step, behavior: 'smooth' });
          });
          pagination.appendChild(dot);
        }
        updatePagination();
      };

      const updateNavigation = () => {
        const hasOverflow = track.scrollWidth > track.clientWidth + 2;
        previousButton.hidden = !hasOverflow;
        nextButton.hidden = !hasOverflow;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        
        // Centrar itens no desktop quando nao ha overflow
        if (window.innerWidth >= 750) {
          track.classList.toggle('is-centered', !hasOverflow);
        } else {
          track.classList.remove('is-centered');
        }
      };

      const scrollOneCard = (direction) => {
        const visibleCard = track.querySelector('[data-tms-category]:not([hidden])');
        if (!visibleCard) return;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        track.scrollBy({ left: direction * (visibleCard.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => scrollOneCard(-1));
      nextButton.addEventListener('click', () => scrollOneCard(1));
      track.addEventListener('scroll', () => {
        updateNavigation();
        updatePagination();
      }, { passive: true });

      // Mouse drag-to-scroll que NÃO bloqueia cliques em links ou botões no PC
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let hasDragged = false;

      track.addEventListener('mousedown', (event) => {
        if (event.button !== 0) return;
        isDown = true;
        hasDragged = false;
        startX = event.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      window.addEventListener('mouseup', () => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        setTimeout(() => { hasDragged = false; }, 60);
      });

      track.addEventListener('mousemove', (event) => {
        if (!isDown) return;
        const x = event.pageX - track.offsetLeft;
        const walk = x - startX;
        if (Math.abs(walk) > 8) {
          hasDragged = true;
          track.classList.add('is-dragging');
          track.scrollLeft = scrollLeft - walk;
        }
      });

      // Apenas cancela o clique se tiver havido um arrastamento real com o rato
      track.addEventListener('click', (event) => {
        if (hasDragged) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      // Cliques nas tabs 100% responsivos no PC e telemóvel
      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          const filter = tab.dataset.tmsFilter;
          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active);
          });
          cards.forEach((card) => {
            card.hidden = card.dataset.tmsCategory !== filter;
          });
          track.scrollLeft = 0;
          requestAnimationFrame(() => {
            updateNavigation();
            buildPagination();
          });
        });
      });

      window.addEventListener('resize', () => {
        updateNavigation();
        buildPagination();
      });
      requestAnimationFrame(() => {
        updateNavigation();
        buildPagination();
      });
    };

    document.querySelectorAll('.tms-favourites').forEach(initialiseFavourites);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('.tms-favourites').forEach(initialiseFavourites);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.homeHero = this.classList.contains('header-wrapper--transparent-home')
        ? document.querySelector('#MainContent .slideshow')
        : null;
      this.updateHomeHeroState();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateHomeHeroState(scrollTop);

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    updateHomeHeroState(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      if (!this.homeHero) return;

      const heroBottom = this.homeHero.offsetTop + this.homeHero.offsetHeight;
      this.header.classList.toggle('header--past-home-hero', scrollTop >= heroBottom - this.header.offsetHeight);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tms-daily-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tms-daily-offer')) {
    customElements.define('tms-daily-offer', class extends HTMLElement {
      connectedCallback() {
        this.clock = this.querySelector('[role="timer"]');
        this.digits = ['hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
        const options = { timeZone: this.dataset.timezone || 'Europe/Lisbon', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' };
        try { this.formatter = new Intl.DateTimeFormat('en-GB', options); }
        catch { this.formatter = new Intl.DateTimeFormat('en-GB', { ...options, timeZone: 'Europe/Lisbon' }); }
        this.onVisibility = () => {
          clearInterval(this.interval);
          if (!document.hidden) {
            this.update();
            this.interval = setInterval(() => this.update(), 1000);
          }
        };
        document.addEventListener('visibilitychange', this.onVisibility);
        this.onVisibility();
      }

      parts(date) {
        return Object.fromEntries(this.formatter.formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
      }

      midnight(now) {
        const current = this.parts(now);
        const wallMidnight = Date.UTC(current.year, current.month - 1, current.day + 1);
        let target = wallMidnight;
        for (let attempt = 0; attempt < 3; attempt++) {
          const local = this.parts(new Date(target));
          const offset = Date.UTC(local.year, local.month - 1, local.day, local.hour, local.minute, local.second) - target;
          target = wallMidnight - offset;
        }
        return target;
      }

      update() {
        const now = new Date();
        if (!this.deadline || now.getTime() >= this.deadline) this.deadline = this.midnight(now);
        const total = Math.max(0, Math.ceil((this.deadline - now.getTime()) / 1000));
        const values = [Math.floor(total / 3600), Math.floor(total % 3600 / 60), total % 60];
        values.forEach((value, index) => {
          const text = String(value).padStart(2, '0');
          if (this.digits[index].textContent !== text) {
            this.digits[index].textContent = text;
            this.digits[index].classList.remove('is-changing');
            void this.digits[index].offsetWidth;
            this.digits[index].classList.add('is-changing');
          }
        });
        this.clock.hidden = false;
      }

      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
